/* eslint-disable */

/**
 *
 * @evaluation refactor
 * @category simple ui
 * @todo needs to be refactored so that data and icons are given as parameters to the component
 *
 */
import { Button, Menu } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import * as registry from "@qpr/client-api-registry";
import clsx from "clsx";
import { t } from "i18next";
import React from "react";
import { useAppContext } from "./../../context/AppCtxProvider";
import { mea_t } from "./../../tplutils/utils";
import { makeThemedStyles } from "./../../viewcomponents/utils";
const useButtonStyles = makeThemedStyles("Selector", (theme) => ({
  root: {
    borderRadius: "2em",
    border: "1px solid #fafafa",
    backgroundColor: "#fff",
    color: "rgba(76,81,87, 0.8)",
    height: "48px",
    fontSize: "1.6em",
    padding: "1.4em 1.3em 1.4em 1.3em",
    textTransform: "none",
    width: "187px",
    "&:hover": {
      backgroundColor: "#fff",
    },
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    "&.customSelector": {
      width: "13.57em",
    },
    "&.customChildSelector": {
      width: "13.57em",
      height: "2.85em;",
      padding: "1.2em 1.3em",
    },
    "&.subChildSelector": {
      width: "22.5em",
      height: "2.85em;",
      padding: "1.2em 1.3em",
    },
  },
  reportItem: {
    fontSize: "1em",
    color: "rgba(17, 94, 103, 1)",
  },
  endIconRtl: {
    marginLeft: theme.spacing(-0.5),
    marginRight: theme.spacing(1),
  },
  Container: {
    display: "flex",
    marginLeft: theme.spacing(2),
    flexDirection: "row-reverse",
  },
  dropDown: {
    "& .MuiMenu-list": {
      border: "2px solid red",
    },
  },
  "& .MuiMenu-list": {
    border: "2px solid red",
  },
  reportSelector: {
    fontSize: "1.6em",
  },
  itemIcon: {
    maxHeight: "100%",
    height: "1.37em",
    width: "1.37em",
    marginRight: "0.58em",
  },
  selectedColor: {
    color: "rgba(17, 94, 103, 1)",
  },
  reportSelectorContainer: {
    marginLeft: "0",
  },
  buttonText: {
    width: "fill-available",
    overflow: "hidden",
    whiteSpace: "pre",
    textOverflow: "ellipsis",
  },
}));
interface WithId {
  id: string;
  name: string;
  JS_ATTR?: string;
}
interface SelectorMenuProps {
  data?: string[];
  customData?: WithId[];
  handleOnClick: (item: any) => void;
  label: string;
  selectedValue: string | undefined;
  custom?: boolean;
  showIcon?: boolean;
  className?: string;
  type?: string;
  optionType?: string;
}
const OptionIcon = (props: { name?: string }) => {
  const Dubai2021 = registry.getSvg("Dubai2021");
  const Dubai2030 = registry.getSvg("Dubai2030");
  const Sector = registry.getSvg("Sector");
  const Entity = registry.getSvg("Entity");
  const { model } = useAppContext();
  const { name } = props;
  const classes = useButtonStyles();
  let icon = null;
  if (name?.includes("dubai")) {
    console.log("Option Icon ", name);
    if (model === "DP2021") {
      icon = Dubai2021;
    } else {
      icon = Dubai2030;
    }
  } else if (name?.includes("government")) icon = Entity;
  else if (name?.includes("sector")) icon = Sector;
  if (!icon) return <></>;
  return React.createElement(icon, { className: classes.itemIcon });
};
const getLabel = (label: string, type?: string) => {
  const { model } = useAppContext();
  return type === "Aim" && model !== "DP2030" ? "Select Aim" : label;
};
const SelectedItem = (props: { data: SelectorMenuProps }) => {
  const classes = useButtonStyles();
  const { showIcon, selectedValue, customData, label, type } = props.data;
  const item =
    customData && customData.find((opt: WithId) => opt.id === selectedValue);
  const ctx = useAppContext();
  return (
    <>
      {showIcon && <OptionIcon name={item?.name?.toLowerCase()} />}
      <div className={classes.buttonText}>
        {item
          ? item.JS_ATTR
            ? mea_t("Name", item.JS_ATTR, ctx.language)
            : t(item.name)
          : t(getLabel(label, type))}
      </div>
    </>
  );
};
const SelectorMenu = (props: SelectorMenuProps) => {
  const {
    data,
    handleOnClick,
    label,
    selectedValue,
    customData,
    showIcon,
    className,
    optionType,
    type,
  } = props;
  const rtl = useAppContext((state) => state.rtl);
  const buttonClasses = useButtonStyles();
  const ctx = useAppContext();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <div
      className={clsx(buttonClasses.Container, {
        [buttonClasses.reportSelectorContainer]: customData,
      })}
      style={
        className?.includes("sub")
          ? { marginLeft: rtl ? "" : "auto", marginRight: rtl ? "auto" : "" }
          : {}
      }
    >
      <Button
        classes={{
          root: clsx(buttonClasses.root, className, {
            [buttonClasses.selectedColor]: selectedValue && showIcon,
          }),
          endIcon: rtl ? buttonClasses.endIconRtl : undefined,
        }}
        aria-controls="dropdown-menu"
        aria-haspopup="true"
        onClick={handleClick}
        endIcon={<ExpandMoreIcon htmlColor="rgba(1, 170, 163, 1)" />}
        style={{ borderRadius: "40px", backgroundColor: "#ffffff" }}
      >
        {!customData ? (
          <div className={buttonClasses.buttonText}>
            {getLabel(label, type)}
          </div>
        ) : (
          <SelectedItem data={props} />
        )}
      </Button>
      <Menu
        id="dropdown-menu"
        className={clsx(buttonClasses.dropDown, {
          [buttonClasses.reportSelector]: customData,
        })}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        getContentAnchorEl={null}
      >
        {data &&
          data.map((item: string, index: number) => {
            return (
              <MenuItem
                key={item}
                value={item}
                selected={item === selectedValue}
                data-testid="sibling-menuitem"
                onClick={(e: any) => {
                  handleOnClick(e.target.textContent);
                  handleClose();
                }}
              >
                {item}
              </MenuItem>
            );
          })}

        {customData &&
          (customData.length > 0 ? (
            customData.map((item: WithId, index: number) => {
              return (
                <MenuItem
                  key={item.id}
                  value={item.id}
                  selected={item.id === selectedValue}
                  classes={{ root: buttonClasses.reportItem }}
                  data-testid="sibling-menuitem"
                  onClick={() => {
                    handleOnClick(item);
                    handleClose();
                  }}
                >
                  {showIcon && <OptionIcon name={item.name.toLowerCase()} />}
                  {item.JS_ATTR
                    ? mea_t("Name", item.JS_ATTR, ctx.language)
                    : t(item.name)}
                  {/* some problem here not returning arabic version of text for entities on configurable reports */}
                </MenuItem>
              );
            })
          ) : (
            <MenuItem classes={{ root: buttonClasses.reportItem }}>
              {t("No Data")}
            </MenuItem>
          ))}
      </Menu>
    </div>
  );
};
export default SelectorMenu;
